import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import api_rest from 'src/app/services/api_rest';
import { CERTIFICADO_INACAL } from 'src/app/models/certificado-inacal';

@Injectable({
  providedIn: 'root'
})
export class CertificadoInacalApiService {

  
  API_RUTA = "api-certificados-verificacion.php";
  API_URI = api_rest.server.API_URI_TDEM;
  API_URI_ALL = this.API_URI + '/' + this.API_RUTA+"?";

  constructor(private http: HttpClient) { }

  getPromiseInicial(nroCertificado, nroSuministro, codigoHash, codigoSeguridad):Promise<CERTIFICADO_INACAL[]> {
    let URL = this.API_URI_ALL;
    if (nroCertificado && nroCertificado !== "null") {
      URL += `nro_certificado=${nroCertificado}&`;
    }

    if (nroSuministro && nroSuministro !== "null") {
      URL += `suministro=${nroSuministro}&`;
    }

    if (codigoHash && codigoHash !== "null") {
      URL += `codigo_has=${codigoHash}&`;
    }

    if (codigoSeguridad && codigoSeguridad !== "null") {
      URL += `codigo_seguridad=${codigoSeguridad}&`;
    }

    URL = URL.endsWith("&") ? URL.slice(0, -1) : URL;
    
    //console.log("CertificadoInacalApiService / getPromiseInicial url del api", URL);
    return this.http.get<CERTIFICADO_INACAL[]>(URL).toPromise(); 
  }

  getFile(email: string, filePath:string): Promise<Blob> {
    const params = new HttpParams()
      .set('email', email)
      .set('path', filePath);
    return this.http.get(`${this.API_URI}/files/getfile`, {
      params,
      responseType: 'blob'
    }).toPromise();
  }

}